import FaqContainer from './FaqContainer';
import FaqBase from './FaqBase';

export { FaqBase };
export default FaqContainer;
